import { render } from "./ExtraServicesSection.vue?vue&type=template&id=2e0e424c"
import script from "./ExtraServicesSection.vue?vue&type=script&lang=js"
export * from "./ExtraServicesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__